import React from 'react';

import { Heading, Container, Row, Col, Text } from 'aplazame-design-system';

import TestimonialComponent from '../TestimonialComponent';

import style from './style.module.scss';

export default function TestimonialsSection({
    title,
    titleTag,
    subtitle,
    testimonials,
    id,
}) {
    return (
        <section aria-labelledby={id}>
            <Container pt={{ xs: 10 }} pb={{ xs: 5, lg: 15 }}>
                <Row>
                    <Col pb={{ xs: 1, lg: 3 }} col={{ lg: 7 }}>
                        <Heading
                            id={id}
                            tag={titleTag}
                            className={`mb-5 ${style.heading}`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                        {subtitle ? (
                            <Text
                                tag="p"
                                className={`mb-5 ${style.subtitle}`}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {subtitle}
                            </Text>
                        ) : null}
                    </Col>
                </Row>
                <Row>
                    {testimonials.map((testimonial, i) => (
                        <Col
                            key={i}
                            col={{ lg: 4 }}
                            pb={{ xs: 7 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            data-sal-delay={`xs-none--lg-${(i % 3) * 100}`}
                        >
                            <TestimonialComponent {...testimonial} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
